import React, { useState, useEffect } from 'react';

import { AlertMessage } from "components";

import { func_validation, isStringTrimNotEmpty } from "functions";
import { Toaster } from 'components/notification/Toaster';

export function useAlertMessage(props) {
    const { 
        addAccount_errorMsg,
        updateAccount_errorMsg,

        isFormSubmissionAttempted,

        getFullAgentCodeList_errorMsg,
        getFullProductDetailList_errorMsg
    } = props;

    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);


    // List loading error
    useEffect(() => {
        if (isStringTrimNotEmpty(getFullAgentCodeList_errorMsg)) {
            Toaster({
                type: "error",
                msg: "Failed to load dealer & sales person code lists",
                timer: 10000
            });
        }
    }, [getFullAgentCodeList_errorMsg]);
    useEffect(() => {
        if (isStringTrimNotEmpty(getFullProductDetailList_errorMsg)) {
            Toaster({
                type: "error",
                msg: "Failed to load product code & product name lists",
                timer: 10000
            });
        }
    }, [getFullProductDetailList_errorMsg]);

    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && 
            isFormSubmissionAttempted) {

            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(addAccount_errorMsg);
    }, [addAccount_errorMsg]);
    useEffect(() => {
        handleError(updateAccount_errorMsg);
    }, [updateAccount_errorMsg]);

    let alertMessageDisplay = isAlertMsgVisible? (
        <div className={"pb-3"}>
            <AlertMessage
                message={alertMsg}
                isVisible={isAlertMsgVisible}
                toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
            />
        </div>
    ):"";

    return {
        alertMessageDisplay
    };
}